import { EqualityFacet, IFacet, IdListFacet, MsiFacet } from './FacetDefinition';
import { SearchType } from './ISearchService';

export class FacetMetadata {
	static programFacets: IFacet[] = [
		new EqualityFacet('language', 'language', 'Instructional Language', 'Language'),
		new EqualityFacet('deliverySpeed', 'speed', 'Delivery Speed', 'DeliverySpeed'),
		new EqualityFacet('deliveryMode', 'mode', 'Delivery Method', 'DeliveryMode'),
		new EqualityFacet('area', 'area', 'Subject Area', 'SubjectArea'),
		new EqualityFacet('level', 'proglevel', 'Program Level', 'ProgramLevel'),
		new MsiFacet('msiCodes', 'msi', 'Minority Serving Institution', 'Msi'),
		new EqualityFacet('state', 'state', 'State', 'State'),
		new IdListFacet('ids', 'ids', 'Favorite Programs')
	];

	static courseFacets: IFacet[] = [
		new EqualityFacet('language', 'language', 'Instructional Language', 'Language'),
		new EqualityFacet('deliverySpeed', 'speed', 'Delivery Speed', 'DeliverySpeed'),
		new EqualityFacet('deliveryMode', 'mode', 'Delivery Method', 'DeliveryMode'),
		new EqualityFacet('area', 'area', 'Subject Area', 'SubjectArea'),
		new EqualityFacet('courseLevel', 'courselevel', 'Course Level', 'CourseLevel'),
		new MsiFacet('msiCodes', 'msi', 'Minority Serving Institution', 'Msi'),
		new EqualityFacet('state', 'state', 'State', 'State'),
		new IdListFacet('ids', 'ids', 'Favorite Courses')
	];

	public static list (searchType: SearchType): IFacet[] {
		switch (searchType) {
			case SearchType.Program: return FacetMetadata.programFacets;
			case SearchType.Course: return FacetMetadata.courseFacets;
			default: return [];
		}
	}
}
